/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import * as _ from 'lodash';

import { selectors as localeSelectors, actions as localeActions } from '../redux/ducks/locale';
import { userSelectors } from '../redux/selectors_authorizedApp';

function mapStateToProps(state) {
  return {
    getMessages: (languageCode) => localeSelectors.getMessages(state, languageCode),
    preferredLanguageCode: userSelectors.getPreferredLanguageCode(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addLocale: (locale, preferredLanguageCode) => {
      dispatch(localeActions.addLocale(locale, preferredLanguageCode));
    },
  };
}

class ConnectedNestedIntlProvider extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      lastLocale: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.locale.language_code !== this.props.locale.language_code) {
      this.setState({
        lastLocale: this.props.locale,
      });
      this.props.addLocale(nextProps.locale, nextProps.preferredLanguageCode);
    }
  }

  render() {
    let languageCode = this.props.locale.language_code;
    let messages = this.props.getMessages(languageCode);
    let messageLength = _.keys(messages).length;
    if (!languageCode || messageLength === 0) {
      languageCode = this.state.lastLocale;
      messages = this.props.getMessages(languageCode);
      messageLength = _.keys(messages).length;
    }

    if (!languageCode || messageLength === 0) { return null; }

    return (
      <IntlProvider
        key={languageCode}
        locale={languageCode}
        messages={messages}
        defaultLocale="en"
      >
        {this.props.children}
      </IntlProvider>
    );
  }
}
ConnectedNestedIntlProvider.propTypes = {
  children: PropTypes.any,
  locale: PropTypes.object,
  addLocale: PropTypes.func,
  getMessages: PropTypes.func,
  preferredLanguageCode: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedNestedIntlProvider);
